import { CustomerPortalField } from 'api/customer-portal/types';
import { HttpClient } from 'api/http-client';
import {
  MarketplaceApp,
  RlMarketplaceAppInstallation,
  RlMarketplaceServerMethod,
  RlMarketplaceWidget,
  RlMarketplaceAppAndInstallation,
  AppField,
  InvokeServerMethodResponse,
} from 'marketplace/types/marketplace';

class RlMarketplaceHTTPClient extends HttpClient {
  public async getInstallationsInAccount() {
    return this.get<RlMarketplaceAppInstallation[]>(
      '/marketplace/installations',
    );
  }

  public async getInstalledMarketplaceApps() {
    return this.get<RlMarketplaceAppAndInstallation[]>(
      '/marketplace/apps/installed',
    );
  }

  public async getInstallationDetails(appId: number) {
    return this.get<RlMarketplaceAppInstallation>(
      `/marketplace/app/${appId}/installation`,
    );
  }

  // /apps/{appId}/version/{versionId}/widgets
  public async getWidgets(appId: number, versionId: number) {
    return this.get<RlMarketplaceWidget[]>(
      `/marketplace/apps/${appId}/version/${versionId}/widgets`,
    );
  }

  public async getServerActions(appId: number, versionId: number) {
    return this.get<RlMarketplaceServerMethod[]>(
      `/marketplace/apps/${appId}/version/${versionId}/server-actions`,
    );
  }

  public async runServerAction(
    appId: number,
    serverActionName: string,
    payload: Record<string, unknown>,
    params?: Record<string, unknown>,
  ) {
    return this.post(
      `/marketplace/apps/${appId}/server-actions/${serverActionName}/run`,
      {
        payload,
      },
      {
        params,
      },
    );
  }

  public async getInvokeServerActionResponse(appId: number, requestId: string) {
    return this.get<InvokeServerMethodResponse>(
      `/marketplace/apps/${appId}/server-actions/response/${requestId}`,
    );
  }

  // /apps/installed-widgets
  public async getInstalledWidgets() {
    return this.get<
      {
        widgets: RlMarketplaceWidget[];
        app: MarketplaceApp;
        installation: RlMarketplaceAppInstallation;
      }[]
    >('/marketplace/apps/installed-widgets');
  }

  public async getWidgetById(
    appId: string,
    versionId: string,
    widgetId: string,
  ) {
    return this.get<RlMarketplaceWidget>(
      `/marketplace/apps/${appId}/version/${versionId}/widgets/${widgetId}`,
    );
  }

  public async enableAppInstallation(appId: number) {
    return this.post(`/marketplace/apps/${appId}/installations/enable`, {});
  }

  public async disableAppInstallation(appId: number) {
    return this.post(`/marketplace/apps/${appId}/installations/disable`, {});
  }

  public async formatWidgetFields(payload: {
    fields: AppField[];
  }): Promise<CustomerPortalField[]> {
    return this.post('/marketplace/fields/format', payload);
  }

  public async deleteAppInstallation(appId: number) {
    return this.delete(`/marketplace/apps/${appId}/installation/`);
  }
}

export const RlMarketplaceApi = new RlMarketplaceHTTPClient();
